import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Plus, Edit, Trash2, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/utils/api';

const AdminVenues = () => {
  const navigate = useNavigate();
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');
    
    if (!token || !userStr) {
      navigate('/admin/login');
      return;
    }
    
    try {
      const user = JSON.parse(userStr);
      if (user.role !== 'admin') {
        navigate('/admin/login');
        return;
      }
    } catch (error) {
      navigate('/admin/login');
      return;
    }
    
    loadVenues();
  }, [navigate]);

  const loadVenues = async () => {
    try {
      const response = await api.get('/venues');
      setVenues(response.data);
    } catch (error) {
      toast.error('Gagal memuat data lapangan');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (venueId) => {
    if (!window.confirm('Yakin ingin menghapus lapangan ini?')) return;

    try {
      await api.delete(`/admin/venues/${venueId}`);
      toast.success('Lapangan berhasil dihapus');
      loadVenues();
    } catch (error) {
      toast.error('Gagal menghapus lapangan');
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <nav className="border-b border-zinc-800 bg-background-paper/50 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/admin/dashboard" className="flex items-center space-x-3">
              <img src="/zero-logo.png" alt="Logo" className="w-10 h-10 object-contain rounded-md" />
              <span className="text-2xl font-heading font-black italic text-primary uppercase">Admin Panel</span>
            </Link>
            <Link to="/admin/dashboard" className="text-zinc-400 hover:text-primary flex items-center gap-2">
              <ArrowLeft className="w-5 h-5" />
              <span>Dashboard</span>
            </Link>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-4xl font-heading font-bold italic uppercase text-white">Kelola Lapangan</h1>
            <div className="flex gap-2">
              <Link
                to="/admin/venues/new"
                data-testid="add-venue-btn"
                className="bg-primary text-black px-6 py-3 rounded-md font-bold uppercase tracking-wide hover:bg-primary-hover transition-all flex items-center gap-2"
              >
                <Plus className="w-5 h-5" />
                Tambah Lapangan
              </Link>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-12">
              <div className="inline-block w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {venues.map((venue) => (
                <div key={venue.id} data-testid={`venue-item-${venue.id}`} className="bg-zinc-900 border border-zinc-800 rounded-lg p-6">
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <h3 className="text-xl font-bold text-white mb-1">{venue.name}</h3>
                      {venue.is_closed ? (
                        <div className="mt-2 inline-block px-3 py-1 rounded-full text-xs font-bold uppercase border border-red-500/20 text-red-400 bg-red-500/10">
                          Tutup
                        </div>
                      ) : (
                        <div className="mt-2 text-xs text-zinc-500">
                          Jam operasional: {String(venue.open_hour ?? 8).padStart(2, '0')}:00 - {String(venue.close_hour ?? 22).padStart(2, '0')}:00
                        </div>
                      )}
                    </div>
                    <div className="text-right">
                      <p className="text-2xl font-black text-primary">
                        Rp {venue.price_per_hour.toLocaleString('id-ID')}
                      </p>
                      <p className="text-xs text-zinc-500">/jam</p>
                    </div>
                  </div>
                  <p className="text-zinc-300 mb-4">{venue.description}</p>
                  <div className="flex gap-2">
                    <Link
                      data-testid={`edit-venue-${venue.id}`}
                      to={`/admin/venues/${venue.id}/edit`}
                      className="flex-1 bg-transparent border-2 border-primary text-primary hover:bg-primary/10 px-4 py-2 rounded-md font-bold uppercase text-sm transition-all flex items-center justify-center gap-2"
                    >
                      <Edit className="w-4 h-4" />
                      Edit
                    </Link>
                    <button
                      data-testid={`delete-venue-${venue.id}`}
                      onClick={() => handleDelete(venue.id)}
                      className="flex-1 bg-red-600 text-white hover:bg-red-700 px-4 py-2 rounded-md font-bold uppercase text-sm transition-all flex items-center justify-center gap-2"
                    >
                      <Trash2 className="w-4 h-4" />
                      Hapus
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default AdminVenues;
